var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('loading'):_c('dg-device-detect',{attrs:{"browsers":_vm.browsersUrl,"t":_vm.t,"url":_vm.loginUrl},on:{"on-continue":_vm.continueOnboarding}})
}
var staticRenderFns = []

export { render, staticRenderFns }